/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getFlightData } from "api/services/common";
import { GetFlightDataResponseType } from "api/response";
import { commonQueryKeys } from "./commonQueryKeys";


export function useGetFlightData(config: Record<string, any> = {}, options?: UseQueryOptions<GetFlightDataResponseType>) {
  return useQuery({
    queryKey: commonQueryKeys.flightData(config),
    queryFn: () => getFlightData(config).then((res) => res.data),
    ...options,
  });
}
